// extracted by mini-css-extract-plugin
export default {"ContactLink":"ContactLink_ContactLink__51oDI","ContactLink__Image":"ContactLink_ContactLink__Image__xpPcB","ContactLink__Name":"ContactLink_ContactLink__Name__7IZ2K"};